//Reference: EN095

import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';
export class TimeAllocationConcept extends Mappeable {
    idTypeConceptImputationPk: number;
    txtTypeConceptImputation: string;
    imputablePai: boolean;
    imputationsChildren: any[];
    typeConceptImputationFatherId: any;

    constructor(o) {
        super(o);
        this.imputationsChildren = _.isUndefined(this.imputationsChildren) || _.isNull(this.imputationsChildren) ? [] : this.imputationsChildren;
        this.imputablePai = _.isUndefined(this.imputablePai) || _.isNull(this.imputablePai) ? false : this.imputablePai;
    }

    public mapToBack() {
        return {
            idTypeConceptImputationPk: this.idTypeConceptImputationPk,
            imputablePai: this.imputablePai,
            txtTypeConceptImputation: this.txtTypeConceptImputation,
            imputationsChildren: this.imputationsChildren,
            typeConceptImputationFatherId: this.typeConceptImputationFatherId
        }
    }
}
